import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { OnlyBackButton } from 'components/base/BottomStepComponent';
import ContentSections from 'components/base/ContentSections';
import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import { couponRecordQueryKey } from 'components/pointRecord/RecordsUrlConfig';

import { createAction } from 'utils';

import './CouponTransactionOverview.scss';
import { getRecordsRelatedTransactionCard } from '../pointRecords/PointTransactionOverview';
import LimitInfoField from 'components/limitInfo/LimitInfoField';

function CouponTransactionOverview({
  isTicket,
}) {
  const queryString = require('query-string');
  const dispatch = useDispatch();
  const history = useHistory();
  const couponTransactionPK = useParams().id;

  useEffect(() => {
    dispatch(
      createAction('couponTransactions/getSingleCouponTransactionRecord')({
        couponTransactionPK,
      }),
    );
    return () => dispatch(createAction("couponTransactions/clearData")())
  }, [couponTransactionPK, dispatch]);

  const { record } = useSelector((state) => ({
    record: state.couponTransactions.selectedCouponTransaction,
  }));

  const dataWithType = (couponTransactionType) => {
    let differentItems = [];
    switch (couponTransactionType) {
      case 'Customer earned':
        differentItems = [
          [{ title: isTicket ? 'Event' : 'Campaign', field: 'displayCampaign', deeplink: record?.campaignLink }],
        ];
        break;
      case 'Customer acquired':
        differentItems = [
          [{ title: 'Points spent', field: 'pointsSpent' }],
          [{ title: isTicket ? 'Event' : 'Campaign', field: 'displayCampaign', deeplink: record?.campaignLink }],
        ];
        break;
      case 'Customer used':
      case 'Admin used':
      case 'Merchant used':
        differentItems = [[{ title: 'Used date', field: 'usedDate' }]];
        break;
      default:
        break;
    }
    let data = [
      [{ title: 'Customer', field: 'name', customerLink: true }],
      [{ title: 'Membership ID', field: 'membershipId' }],
      [{ title: 'Event type', field: 'eventType' }],
      [{ title: 'Record type', field: 'displayType' }],
      ...differentItems,
      [{ title: `${isTicket ? 'Ticket' : 'Coupon'} set ID`, field: 'displayCouponTemplateInfo'}],
      [{ title: `${isTicket ? 'Ticket' : 'Coupon'} ID and name`, field: 'displayCoupon' }],
      [{ title: 'Reference ID', field: 'couponReferenceId'}],
      [{ title: 'Expiry date', field: 'couponExpiryDate' }],
    ];
    if (record.displayAdministrator) {
      data = [
        ...data,
        [({ title: 'Administrator', field: 'displayAdministrator'})]
      ]
    }
    data.push(
      [{ title: 'Remarks (optional)', field: 'remarks'}],
    )
    data.push([{ title: 'Creation date', field: 'detailDisplayCreationDate' }],)
    return data;
  };

  const tabs = [
    {
      name: '',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={[
              <MembershipInfoCard
                title={''}
                data={record}
                fields={dataWithType(
                  record.displayType,
                )}
              />,
              ...(record?.transaction?.pk ? [
                getRecordsRelatedTransactionCard(record.transaction)
              ] : []),
              ...record?.reachLimitInfo?.reachLimit
                ? [
                  <LimitInfoField
                    title="REWARD REACHED LIMIT"
                    reachLimitInfo={record?.reachLimitInfo}
                  />
                ]
                : [],
            ]}
            hidePreview={true}
            // sectionStyle="coupon-transaction-record-detail-section"
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <CustomListComponent
        caution={{
          detail: '', //view coupon records
          title: `View ${isTicket ? 'Ticket' : 'Coupon'} Records`,
        }}
        breadcrumb={<CustomBreadcrumb />}
        hideTab={true}
        tabs={tabs}
      />
      <OnlyBackButton
        backAction={() => {
          history.push({
            pathname: isTicket ? '/ticket_records' : '/coupon_records',
            search: queryString.stringify({
              [couponRecordQueryKey.searchKey]: '',
              [couponRecordQueryKey.page]: 1,
              [couponRecordQueryKey.rank]: true,
              [couponRecordQueryKey.tab]: 'all',
            }),
          });
        }}
      />
    </>
  );
}

export default CouponTransactionOverview;
